export const isSidebarPage = () => {
  const allowedSidebarPaths = [
    "/clients",
    "/projects",
    "/test-cases",
    "/dashboard",
  ];
  return allowedSidebarPaths.includes(window.location.pathname);
};

export const getClientId = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get("client_id");
};

export const formatDate = (date) => {
  const d = new Date(date);

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  return `${day}-${month}-${year}`;
};


export const isElectronApp = () => {
  if (process.env.REACT_APP_ELECTRON === 'true') {
    return true;
  }

  if (typeof window !== 'undefined' && window.electronAPI) {
    return true;
  }

  if (typeof window !== 'undefined' && window.location?.protocol === 'file:') {
    return true;
  }

  if (
    typeof navigator !== 'undefined' &&
    navigator.userAgent &&
    navigator.userAgent.toLowerCase().includes('electron')
  ) {
    return true;
  }

  if (
    typeof process !== 'undefined' &&
    process.versions &&
    process.versions.electron
  ) {
    return true;
  }

  return false;
};
